<template>
  <div>
    <div class="tTitle mt30">
      练习答案
      <span>(长按图片保存至手机)</span>
    </div>
    <div class="imgContent">
      <div
        v-for="(img,index) in unitImg"
        :key="index"
      >
        <div class="pb30">
          <img
            :src="contentHost+img.smallPath"
            @click="viewPhoto(index)"
          />
        </div>
      </div>
    </div>
    <div
      class="btnTop"
      @click="jumpTop"
      v-if="backTopShow"
    ></div>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
export default {
    name: 'ExamAnswer',
    data () {
        return {
            backTopShow: false,
            contentHost: '',
            unitImg: [],
            msg: '网络数据请求异常',
            imgShow: false,
            imgIndex: 0,
            pos: 0,
            images: []
        }
    },
    created: function () {
        var that = this;
        var unitObj = JSON.parse(sessionStorage.c_contentContents);
        var host = that.contentHost = sessionStorage.c_host;
        let { pos } = paramsHelper.decode(this.$route.query.params)

        that.pos = pos;
        var unit = that.unitImg = unitObj[pos];
        var imgurls = [];
        for (var i = 0, len = unit.length; i < len; i++) {
            var path = unit[i].path;
            var imgurl = host + path;
            imgurls.push(imgurl);
        }
        that.images = imgurls;
    },
    mounted: function () {

    },
    destroyed: function () {

    },
    methods: {
        jumpTop: function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        changeImg: function (index) {
            this.imgIndex = index;
        },
        viewPhoto: function (index) {
            var that = this;
            this.$ImagePreview({
                images: that.images,
                startPosition: index,
                onClose () {
                    // do something
                }
            });
        }
    }
}
</script>

<style scope lang="less">
</style>
